
import React, { useEffect, useState, useRef } from 'react';
import './Product.scss';
import Header from '../../Components/Header';
import Footer from '../Footer';
import CourseNew from '../../Assets/Product/homepage.jpg';
import ProctIg from '../../Assets/proct.jpg'
import DSA from '../../Assets/Product/newDSA.png';
import CourseOverall from '../../Assets/Product/newoverallcourse.jpg';
// Removed PracticeNew; using newCourse for second section
// Using newCourse for second sectioProductn
import newCourse from '../../Assets/Product/courseremovebg.jpg';
function Product() {
  const [courses, setCourses] = useState(0);
  const [questions, setQuestions] = useState(0);
  const [students, setStudents] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const counterRef = useRef(null);
  const tripleWrapperRef = useRef(null);
  const [showBlueBox, setShowBlueBox] = useState(false);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  useEffect(() => {
    // Scroll animation for stat items
    const statItems = document.querySelectorAll('.stat-item');
    // Scroll animation for identity sections
    const identityElements = document.querySelectorAll('.identity-section .identity-left h2, .identity-section .identity-right > div');
    // Scroll animation for scroll sections
    const scrollTextItems = document.querySelectorAll('.scroll-text-item');
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    };

    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, observerOptions);

    statItems.forEach((item) => scrollObserver.observe(item));
    identityElements.forEach((item) => scrollObserver.observe(item));
    scrollTextItems.forEach((item) => scrollObserver.observe(item));

    // Counter animation
    const counterObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounter(setCourses, 10, 1500);
          animateCounter(setQuestions, 2500, 2000);
          animateCounter(setStudents, 3000, 1800);
        }
      },
      { threshold: 0.3 }
    );

    const currentRef = counterRef.current;
    if (currentRef) {
      counterObserver.observe(currentRef);
    }

    return () => {
      scrollObserver.disconnect();
      if (currentRef) {
        counterObserver.unobserve(currentRef);
      }
    };
  }, [hasAnimated]);

  // Separate effect for triple wrapper scroll detection
  useEffect(() => {
    const el = tripleWrapperRef.current;
    if (!el) return;

    const handleTripleScroll = () => {
      const rect = el.getBoundingClientRect();
      const wrapperTop = rect.top;      // distance from top of viewport
      const wrapperBottom = rect.bottom; // distance from top of viewport
      const buffer = 50; // px above viewport bottom

      // Show only after top has reached (passed) the top of viewport
      // and hide after bottom leaves (passes) 50px above the bottom of viewport.
      const hasTopReached = wrapperTop <= 0; // top pinned or scrolled past
      const bottomStillVisible = wrapperBottom >= (window.innerHeight - buffer); // bottom not yet passed 50px above viewport bottom
      const shouldShow = hasTopReached && bottomStillVisible;
      setShowBlueBox(prev => prev === shouldShow ? prev : shouldShow);
    };

    window.addEventListener('scroll', handleTripleScroll, { passive: true });
    handleTripleScroll();
    return () => window.removeEventListener('scroll', handleTripleScroll);
  }, []);

  const animateCounter = (setter, target, duration) => {
    let start = 0;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setter(target);
        clearInterval(timer);
      } else {
        setter(Math.floor(start));
      }
    }, 16);
  };

  // Fade-in when center of element aligns with viewport middle
  useEffect(() => {
    const items = Array.from(document.querySelectorAll('.triple-left.fade-track'));
    if (!items.length) return;

    const handleFade = () => {
      const mid = window.innerHeight / 2; // vertical midpoint
      const buffer = 50; // hysteresis buffer to avoid rapid toggle
      let activeIdx = -1;
      items.forEach((el, idx) => {
        const r = el.getBoundingClientRect();
        const intersects = r.top <= (mid + buffer) && r.bottom >= (mid - buffer);
        if (intersects) {
          el.classList.add('in-view');
          if (activeIdx === -1) activeIdx = idx;
        }
        // Do NOT remove in-view when leaving center
      });
      if (activeIdx !== -1 && activeIdx !== currentSectionIndex) {
        setCurrentSectionIndex(activeIdx);
      }
    };
    window.addEventListener('scroll', handleFade, { passive: true });
    handleFade();
    return () => window.removeEventListener('scroll', handleFade);
  }, [currentSectionIndex]);

  return (
    <div className="ProductPageWrapper">
      <div className="Head_wrap">
        <Header/>
      </div>
      <div className="product-page">
        <div className="content-left">
      <h1
  style={{
    color: "#053859",
    fontSize: "clamp(1.65rem, 4vw, 2.5rem)",
    fontWeight: "900",
    fontFamily: "poppins"
  }}
>
  Looking for right place for Improve Building logical thinking to crack interviews
</h1>
          <p style={{color: "#053859", fontSize: "clamp(1rem, 2vw, 1.2rem)", fontWeight: "500", fontFamily: "poppins"}}>Sharpen your logical thinking and problem-solving skills with our structured learning platform designed for real interview success</p>
          <button
            className="explore-button"
            style={{display:'inline-block'}}
            onClick={() => window.location.href = 'mailto:info@thebettertomorrow.in?subject=Course%20Booking%20Request'}
          >
            Book Now
          </button>
        </div>
        <div className="content-right">
          <div className="laptop-mockup">
            <div className="laptop-screen">
              <img src={CourseNew} alt="Product preview" style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px'}} />
            </div>
          </div>
        </div>
      </div>
      
      <div className="stats-counter" ref={counterRef}>
        <div className="stat-item">
          <div className="stat-number">{courses}+</div>
          <div className="stat-label">Courses</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">{questions}+</div>
          <div className="stat-label">Questions</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">{students}+</div>
          <div className="stat-label">Enrolled <br></br>Students</div>
        </div>
      </div>

      {/* Triple Sections (Left text, right blank) wrapped */}
      <div className="triple-wrapper" ref={tripleWrapperRef}>
      <div className="triple-sections">
        <div className="triple-section">
            {/* Inline blue box for mobile/tablet */}
            <div className="inline-blue">
              <div className="white-card">
                <img src={DSA} alt="Company preview" className="mockup-img fade-in" />
              </div>
            </div>
            <div className="triple-left fade-track identity-text">
            <h2 className="triple-title">Crack High Package </h2>
            <p className="triple-desc">
              Master logic, DSA, and real product-based challenges to crack top tech interviews, boost problem-solving skills, and secure high-package offers confidently.
              Sharpen your analytical thinking with hands-on coding practice that mirrors real industry scenarios.
            </p>
          </div>
          <div className="triple-right" />
        </div>
        <div className="triple-section">
            {/* Inline blue box for mobile/tablet */}
            <div className="inline-blue">
              <div className="white-card">
                <img src={newCourse} alt="Course preview" className="mockup-img fade-in" />
              </div>
            </div>
            <div className="triple-left fade-track identity-text">
            <h2 className="triple-title">Engage problem solving skills</h2>
            <p className="triple-desc">Master problem-solving techniques with comprehensive coding challenges designed for interview success.</p>
          </div>
          <div className="triple-right" />
        </div>
        <div className="triple-section">
            {/* Inline blue box for mobile/tablet */}
            <div className="inline-blue">
              <div className="white-card">
                <img src={CourseOverall} alt="Reports preview" className="mockup-img fade-in" />
              </div>
            </div>
            <div className="triple-left fade-track identity-text">
            <h2 className="triple-title">Logic &amp; Code Challenges</h2>
            <p className="triple-desc">Test your logical and programming skills using various logical building problems.</p>
          </div>
          <div className="triple-right" />
        </div>
          <div className="triple-section">
              {/* Inline blue box for mobile/tablet */}
              <div className="inline-blue">
                <div className="white-card">
                    <img src={CourseNew} alt="Product preview" className="mockup-img fade-in" />
                </div>
              </div>
              <div className="triple-left fade-track identity-text">
              <h2 className="triple-title">Track Your Progress</h2>
              <p className="triple-desc">Monitor your learning journey with detailed analytics and insights into your performance.</p>
            </div>
            <div className="triple-right" />
          </div>
        <div className="triple-section">
            {/* Inline blue box for mobile/tablet */}
            <div className="inline-blue">
              <div className="white-card">
                <img src={ProctIg} alt="Course preview" className="mockup-img fade-in" />
              </div>
            </div>
            <div className="triple-left fade-track identity-text">
            <h2 className="triple-title">Track with proctoring</h2>
            <p className="triple-desc">Test your problem solving skills with realtime proctoring enabled assignment without malpratices</p>
          </div>
          <div className="triple-right" />
        </div>
      </div>
      </div>
      {/* Fixed simple white card (400x300) with image fade */}
      <div className={`blue-box ${showBlueBox ? 'visible' : ''}`}>
        <div className="white-card">
          <img
            key={currentSectionIndex}
            src={
              currentSectionIndex === 0
                ? DSA
                : currentSectionIndex === 1
                ? newCourse
                : currentSectionIndex === 2
                ? CourseOverall
                 : currentSectionIndex === 3
                 ? CourseNew
                : currentSectionIndex === 4
                ? ProctIg
                : DSA
            }
            alt={
              currentSectionIndex === 0
                ? 'Company preview'
                : currentSectionIndex === 1
                ? 'Course preview'
                : currentSectionIndex === 2
                ? 'Reports preview'
                : currentSectionIndex === 4
                ? 'Course preview'
                : 'Product preview'
            }
            className="mockup-img fade-in"
          />
        </div>
      </div>

      {/* Scroll Text Section */}
    <Footer/>
     
    </div>
    );
}

export default Product;
